import { FC, useMemo } from 'react'
import {
  ImageCaption,
  ImageTransformer,
  unwrapMedia,
} from 'src/relay/Transformers/ImageTransformer'
import IllustrationPush, {
  IllustrationPushProps,
} from 'src/components/IllustrationPush'

import { BlockProps } from '../props'

import { IllustrationPushBlockProps } from './props'

const IllustrationPushBlock: FC<BlockProps<IllustrationPushBlockProps>> = ({
  data,
}) => {
  const props: IllustrationPushProps = useMemo(
    () => ({
      pictureProps: {
        imageProps: ImageTransformer(unwrapMedia(data.imageDesktop)),
        mobileImageProps: ImageTransformer(unwrapMedia(data.imageMobile)),
      },
      caption: ImageCaption(unwrapMedia(data.imageDesktop)),
    }),
    [data]
  )

  return <IllustrationPush {...props} />
}

export default IllustrationPushBlock
